import Type from "./Type";

export default class MCBoolean extends Type {
    private formatOptions: { trueLabel?: string; falseLabel?: string };
    constructor(formatOptions?: { trueLabel?: string; falseLabel?: string }) {
        super();
        this.formatOptions = formatOptions || {};
        this.formatOptions.trueLabel = this.formatOptions.trueLabel || "True";
        this.formatOptions.falseLabel = this.formatOptions.falseLabel || "False";
    }

    public formatValue(value: number | string | boolean): string {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "string") {
            value = value.toLowerCase() === "true" || value === "1";
        } else if (typeof value === "number") {
            value = value === 1;
        }
        return value ? this.formatOptions.trueLabel : this.formatOptions.falseLabel;
    }

    public parseValue(value: string | number): boolean {
        if (!value) {
            return false;
        }
        if (typeof value === "number") {
            return value === 1;
        }
        value = value.trim().toLowerCase();
        if (value === this.formatOptions.trueLabel?.toLowerCase() || value === "true" || value === "1") {
            return true;
        }
        return false;

    }
    
    public validateValue(): void {
        return;
    }
}